import { MsalService } from '@azure/msal-angular';
import { Observable, catchError, from, of, switchMap } from 'rxjs';
import { Injectable } from '@angular/core';
import { ISandboxTokenAcquireResponse, ISandboxTokenService } from '@lms-approval/onehub-sandbox';
import { AccountInfo } from '@azure/msal-browser';
import { LocalStorageService } from '@adnoc/servicebox';

@Injectable()
export class TokenService implements ISandboxTokenService {
  constructor(private msalService: MsalService, private localStorageService: LocalStorageService) {}

  getToken$(scope: string): Observable<ISandboxTokenAcquireResponse | null> {
    return from(this.msalService.instance.handleRedirectPromise()).pipe(
      switchMap((authResponse) => {
        const account = this.getActiveAccountState();

        if (authResponse) {
          return of(authResponse);
        }

        if (account) {
          this.msalService.instance.setActiveAccount(account);

          return this.msalService
            .acquireTokenSilent({
              account,
              scopes: [scope],
            })
            .pipe(catchError(() => of(null)));
        }

        return of(null);
      }),
    );
  }

  private getActiveAccountState(): AccountInfo | null {
    let activeAccount = this.msalService.instance.getActiveAccount();

    if (!activeAccount && this.msalService.instance.getAllAccounts().length > 0) {
      activeAccount = this.msalService.instance.getAllAccounts()[0];
    }

    return activeAccount;
  }
}
